import {
  DELETE_MATRIX_FOLDER_LOCKED_MESSAGE,
  DELETE_MODULE_WITH_MATRICES_LOCKED_MESSAGE,
  DELETE_QUALITY_RECORDS_ROOT_LOCKED_MESSAGE,
  REMOVE_MATRIX_LINK_LOCKED_MESSAGE,
} from '../config/messages';
import type { DirectoryTreeNode } from './types';

export function resolveDeleteLockMessage(node: DirectoryTreeNode): string | null {
  if (node.kind === 'matrix') {
    return REMOVE_MATRIX_LINK_LOCKED_MESSAGE;
  }
  if (node.kind === 'module') {
    return node.holdsMatrixLinks === true ? DELETE_MODULE_WITH_MATRICES_LOCKED_MESSAGE : null;
  }
  if (node.matrixPlacementDeleteLock === 'QUALITY_RECORDS_ROOT') {
    return DELETE_QUALITY_RECORDS_ROOT_LOCKED_MESSAGE;
  }
  if (node.matrixPlacementDeleteLock === 'MATRIX_FOLDER') {
    return DELETE_MATRIX_FOLDER_LOCKED_MESSAGE;
  }
  return null;
}

export function resolveSelectionDeleteLockMessage(nodes: DirectoryTreeNode[]): string | null {
  for (const node of nodes) {
    const message = resolveDeleteLockMessage(node);
    if (message !== null) {
      return message;
    }
  }
  return null;
}
